<div class="story-run-params-container">
  @if (loading) {
    <div class="loading">
      {{ "story-run-params.message.loading" | translate }}
    </div>
  }

  @if (!loading && notFound) {
    <div class="empty">
      {{ "story-run-params.message.not-found" | translate }}
    </div>
  }

  @if (!loading && storyParams) {
    @if (paramItems.length > 0) {
      <section class="params-section">
        <h5 class="params-heading">
          {{ "story-run-params.heading.main" | translate }}
        </h5>
        <dl class="params-list">
          @for (item of paramItems; track item) {
            <dt class="param-label">{{ item.label }}</dt>
            <dd class="param-value">{{ formatValue(item.value) }}</dd>
          }
        </dl>
      </section>
    }
    @if (promptParamItems.length > 0) {
      <section class="params-section">
        <h5 class="params-heading">
          {{ "story-run-params.heading.prompt-params" | translate }}
        </h5>
        <dl class="params-list">
          @for (item of promptParamItems; track item) {
            <dt class="param-label">{{ item.label }}</dt>
            <dd class="param-value">{{ formatValue(item.value) }}</dd>
          }
        </dl>
      </section>
    }
  }
</div>
